import { formatNumber } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ReportBajaSinComision as ReportBajaSinDispersion, ReportBaseEmpleado } from 'src/app/model/nomina-models';
import { NominaService } from 'src/app/services/nomina.service';
import Swal from 'sweetalert2';

@Component({
  selector: "app-nomina",
  templateUrl: "./nomina.component.html",
  styleUrls: ["./nomina.component.css"],
})
export class NominaComponent implements OnInit {
  public viewStatus = 0; // 0:spinner, 1:Reporte Bajas

  dtOptions1 = {
    order: [],
    responsive: true,
    columnDefs: [
      { responsivePriority: 1, targets: 0 },
      { responsivePriority: 2, targets: -1 },
      { responsivePriority: 3, targets: 1 },
      { responsivePriority: 4, targets: -2 },
      { responsivePriority: 5, targets: -3 },
      { responsivePriority: 6, targets: -4 },
      { responsivePriority: 7, targets: -5 },
      { responsivePriority: 8, targets: -6 },
      { responsivePriority: 9, targets: -7 },
      { responsivePriority: 10, targets: -8 },
    ],
    select: "single",
    bLengthChange: true,
    searching: true,
    dom: '<"row"<"col"l><"col"<"text-center"B>><"col"f>><"row"<"col"t>><"row"<"col"i><"col"p>>',
    buttons: ["csv", "excel"],
    autoWidth: false,
    pagingType: "full_numbers",
    paging: true,
    pageLength: 25,
    language: {
      processing: "Procesando...",
      search: "Buscar:",
      lengthMenu: "Mostrar _MENU_ elementos",
      info: "Mostrando del _START_ al _END_ de _TOTAL_ elementos",
      infoEmpty: "Mostrando ningún elemento.",
      infoFiltered: "(filtrado _MAX_ elementos total)",
      infoPostFix: "",
      loadingRecords: "Cargando registros...",
      zeroRecords: "No se encontraron registros",
      emptyTable: "No hay datos disponibles en la tabla",
      paginate: {
        first: "Primero",
        previous: "Anterior",
        next: "Siguiente",
        last: "Último",
      },
      aria: {
        sortAscending: ": Activar para ordenar la tabla en orden ascendente",
        sortDescending: ": Activar para ordenar la tabla en orden descendente",
      },
    },
  };

  public reportBajasSinDispersion: ReportBajaSinDispersion[];

  constructor(
    private nominaService: NominaService
  ) { }

  ngOnInit() {
    this.loadReport();
  }

  loadReport() {
    this.viewStatus = 0;
    this.nominaService.getReportBajasSinComision().subscribe(
      (resp) => {
        console.log(resp);
        if (resp.httpStatusCode == 200) {
          this.reportBajasSinDispersion = resp.data;
          this.viewStatus = 1;
        } else {
          console.log(resp.messageError);
          this.viewStatus = 0;
          Swal.fire("Ocurrió un error al intentar cargar la página");
        }
      },
      (error) => {
        console.log(error);
        this.viewStatus = 0;
        Swal.fire("Ocurrió un error al intentar cargar la página");
      }
    );
  }

  releasePayment(item: ReportBajaSinDispersion, simulated: boolean) {
    this.viewStatus = 0;
    console.log("Liberar: ", item);
    this.nominaService
      .releasePayment(item.asesorId, item.fechaCobro, simulated)
      .subscribe(
        (resp) => {
          console.log(resp);
          if (resp.httpStatusCode == 200) {
            if (simulated) {
              Swal.fire("Detalles de comisión", this.toStringWithoutPago(resp.data), "info");
            } else {
              Swal.fire("Solicitud de Liberación", resp.message, "success");
            }
          } else {
            Swal.fire("Solicitud de Liberación", resp.message, "error");
          }
          this.viewStatus = 1;
        },
        (error) => {
          console.log(error);
          Swal.fire(
            "Solicitud de Liberación",
            "Motivo: " + error.messageError,
            "error"
          );
          this.viewStatus = 1;
        }
      );
  }

  private toStringWithoutPago(rep: ReportBaseEmpleado): string {
    let str: string = "";

    str += "Mes: " + rep.mes + "<br>";
    str += "Venta: " + rep.venta + "<br>";
    str += "Distribuidor: " + rep.distribuidor + "<br>";
    str += "Tipo de Comision: " + rep.tipoComision + "<br>";
    str += "Id Asesor: " + rep.asesorId + "<br>";
    str += "Nombre Asesor: " + rep.asesorNombre + "<br>";
    str += "Direccion: " + rep.direccion + "<br>";
    str += "Entidad: " + rep.entidad + "<br>";
    str += "Sucursal: " + rep.sucursal + "<br>";
    str += "Departamento: " + rep.departamento + "<br>";
    str += "Puesto: " + rep.puesto + "<br>";
    str += "Colocacion: " + rep.colocacion + "<br>";
    str += "Monto Comision: " + rep.montoComision;

    return str;
  }

  getAmountFormat(num: number) {
    return formatNumber(Number(num), "en-US", "1.2");
  }
}